"use client"

import { useRef, useState } from 'react'

export default function AnimatedButton({ 
  children, 
  type = "button", 
  onClick, 
  className = "",
  disabled = false 
}) {
  const buttonRef = useRef(null)
  const [glowPosition, setGlowPosition] = useState({ x: 0, y: 0 })
  const [glowOpacity, setGlowOpacity] = useState(0)

  const handleMouseMove = (e) => {
    if (!buttonRef.current) return
    
    const rect = buttonRef.current.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top
    
    setGlowPosition({ x, y })
  }

  const handleMouseEnter = () => {
    setGlowOpacity(1)
  }

  const handleMouseLeave = () => {
    setGlowOpacity(0)
  }

  return (
    <div className={`relative inline-block group w-full ${className}`}>
      <button
        ref={buttonRef}
        type={type}
        onClick={onClick}
        disabled={disabled}
        onMouseMove={handleMouseMove}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="animate-[slideInBlur_0.8s_ease-out_1.2s_forwards] relative z-10 overflow-hidden transition-[transform] duration-150 ease-out active:scale-[0.98] text-white bg-neutral-900/60 dark:bg-neutral-800/60 border-white/20 dark:border-white/10 border rounded-xl pt-3 pr-6 pb-3 pl-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] w-full disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span className="relative z-10 inline-flex items-center justify-center gap-2 font-semibold w-full">
          {children}
          <svg 
            className="h-5 w-5 transition-transform duration-200 ease-out group-hover:translate-x-0.5" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              d="M5 12h14M13 5l7 7-7 7" 
            />
          </svg>
        </span>
        <span className="pointer-events-none absolute bottom-0 left-1/2 right-1/2 h-px bg-gradient-to-r from-transparent via-white to-transparent opacity-80 transition-[left,right] duration-500 ease-out group-hover:left-0 group-hover:right-0"></span>
        <span 
          className="glow pointer-events-none absolute inset-0 -z-10 rounded-xl" 
          aria-hidden="true"
          style={{
            background: `radial-gradient(600px circle at ${glowPosition.x}px ${glowPosition.y}px, rgba(255,255,255,.15), transparent 40%)`,
            opacity: glowOpacity,
            transition: 'opacity 0.3s ease-out'
          }}
        ></span>
      </button>
      <span 
        className="pointer-events-none absolute -bottom-3 left-1/2 z-0 h-6 w-44 -translate-x-1/2 rounded-full opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100" 
        style={{
          background: 'radial-gradient(60% 100% at 50% 50%, rgba(255,255,255,.55), rgba(255,255,255,.28) 35%, transparent 70%)',
          filter: 'blur(10px) saturate(120%)'
        }}
        aria-hidden="true"
      ></span>
    </div>
  )
}

